module.exports = __webpack_public_path__ + "static/media/Automotriz.c0fe50cf.jpg";